import { Box } from '@mantine/core';
import { useId } from 'react';

import type { IconPropsType } from './types';

export const FlagViIcon = ({ size = 24, sx, ...props }: IconPropsType) => {
  const id = useId();

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath={`url(#${id})`}>
          <path d="M24 0H0V24H24V0Z" fill="#DA251D" />
        </g>
        <path
          d="M13.4167 10.202L12 6L10.5833 10.202H6L9.70836 12.798L8.29164 17L12 14.4032L15.7084 17L14.2916 12.798L18 10.202H13.4167Z"
          fill="#FFFF00"
        />
        <defs>
          <clipPath id={id}>
            <rect width="24" height="24" rx="12" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Box>
  );
};
